import React from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

interface LoadingOverlayProps {
  isLoading: boolean;
  message?: string;
  fullScreen?: boolean;
}

/**
 * A reusable loading overlay component that displays a spinner and optional message
 */
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading,
  message = 'Loading...',
  fullScreen = true,
}) => {
  if (!isLoading) return null;

  return (
    <div
      className={`${
        fullScreen
          ? 'fixed inset-0 z-50 flex items-center justify-center'
          : 'relative flex items-center justify-center py-8'
      } bg-white bg-opacity-90`}
    >
      <div className="text-center">
        <AiOutlineLoading3Quarters className="mx-auto h-12 w-12 text-blue-600 animate-spin" />
        {message && (
          <p className="mt-4 text-lg font-medium text-gray-700">{message}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
